// Setting APIs
export const SETTING_API_01: string = "Brand";
export const SETTING_API_02: string = "Category";
export const SETTING_API_03: string = "Doctype";
export const SETTING_API_04: string = "Industry";
export const SETTING_API_05: string = "Measuringunits";
export const SETTING_API_06: string = "Package";
export const SETTING_API_07: string = "Product";
export const SETTING_API_08: string = "Subcategory";
export const SETTING_API_09: string = "Doccategory";
export const SETTING_API_10: string = "Bank";
export const SETTING_API_11: string = "Bankbranch";
export const SETTING_API_12: string = "Country";
export const SETTING_API_13: string = "Taxtype";
export const SETTING_API_14: string = "Warehouseparam";
export const SETTING_API_15: string = "Warehouse";
export const SETTING_API_16: string = "Reasoncategory";
export const SETTING_API_17: string = "Reasontype";
export const SETTING_API_19: string = "Charges";
export const SETTING_API_20: string = "Maincategory";
export const SETTING_API_21: string = "Genericname";

// Login API (Post API)
export const LOGIN_API: string = "Login/Login";
export const LOGOUT_API: string = "Login/Logout";
export const LOGIN_API_2: string = "Login/Transferlogin";

// Report
export const REPORT_API_01: string = "Reports";
export const REPORT_API_02: string = "Generatereport";

// Supplier
export const SUPPLIER_API_01: string = "Supplier";
export const SUPPLIER_API_02: string = "Supplierlist";
export const SUPPLIER_API_03: string = "Supplierdetails";
export const SUPPLIER_API_04: string = "Supplierproducts";
export const SUPPLIER_API_05: string = "Supplieridentitytypes";
export const SUPPLIER_API_06: string = "Supplierbranch";
export const SUPPLIER_API_07: string = "Supplierbank";
export const SUPPLIER_API_08: string = "Suppliermetadata";
export const SUPPLIER_API_09: string = "Supplierdocs";
export const SUPPLIER_API_10: string = "Suppliercharges";
export const SUPPLIER_API_11: string = "Supplierchargetype";

// Supplier product
export const SUPPLIER_PRODUCT_API_01: string = "Supplierproducts";
export const SUPPLIER_PRODUCT_API_02: string = "Supplierproductdoc";
export const SUPPLIER_PRODUCT_API_03: string = "Supplierproductdetails";

// GRN
export const GRN_API_01: string = "Grn";
export const GRN_API_02: string = "Grnlist";
export const GRN_API_03: string = "Grnstatus";
export const GRN_API_04: string = "Grnlistfilter";
export const GRN_API_05: string = "Updategrn";
export const GRN_API_06: string = "Updategrnbasic";
export const GRN_API_07: string = "Updategrndocs";
export const GRN_API_08: string = "Updategrnproduct";
export const GRN_API_09: string = "Updategrnproductreturn";
export const GRN_API_10: string = "Grnstatustypes";
export const GRN_API_11: string = "Grnbulkstatus";
export const GRN_API_12: string = "Grntransactionstatustypes";
export const GRN_API_13: string = "Grndynamiclist";

// Item
export const ITEM_API_01: string = "Item";
export const ITEM_API_02: string = "Importitemdata";
export const ITEM_IMPORT_STAGING_API: string = "ItemImportStaging";
export const ITEM_IMPORT_STAGING_CLASSIFY: string = "ItemImportStaging/classify";
export const ITEM_IMPORT_STAGING_VALIDATE: string = "ItemImportStaging/validate";
export const ITEM_IMPORT_STAGING_PREVIEW: string = "ItemImportStaging/preview-validate";
export const ITEM_IMPORT_STAGING_FINALIZE: string = "ItemImportStaging/finalize";
export const ITEM_IMPORT_STAGING_MARK_UNPOSTED: string = "ItemImportStaging/mark-unposted";
export const ITEM_META_API: string = "Itemmeta";
export const ITEM_CREATE_ITEMS_API: string = "Item/CreateItems";
export const ITEM_GET_VARIANT_TYPES: string = "Item/Getitemvarianttypes";
export const ITEM_CREATE_VARIANT_TYPE: string = "Item/Createitemvarianttype";

// Upload
export const UPLOAD_API: string = "Upload/upload";

// Optional: Create enums for better type safety and organization
export enum SettingApiEndpoints {
  BRAND = "Brand",
  CATEGORY = "Category",
  DOCTYPE = "Doctype",
  INDUSTRY = "Industry",
  MEASURING_UNITS = "Measuringunits",
  PACKAGE = "Package",
  PRODUCT = "Product",
  SUBCATEGORY = "Subcategory",
  DOC_CATEGORY = "Doccategory",
  BANK = "Bank",
  BANK_BRANCH = "Bankbranch",
  COUNTRY = "Country",
  TAX_TYPE = "Taxtype",
  WAREHOUSE_PARAM = "Warehouseparam",
  WAREHOUSE = "Warehouse",
  REASON_CATEGORY = "Reasoncategory",
  REASON_TYPE = "Reasontype",
  CHARGES = "Charges",
  MAIN_CATEGORY = "Maincategory",
  GENERIC_NAME = "Genericname",
}

export enum LoginApiEndpoints {
  LOGIN = "Login/Login",
  LOGOUT = "Login/Logout",
  TRANSFER_LOGIN = "Login/Transferlogin",
}

export enum ReportApiEndpoints {
  REPORTS = "Reports",
  GENERATE_REPORT = "Generatereport",
}

export enum SupplierApiEndpoints {
  SUPPLIER = "Supplier",
  SUPPLIER_LIST = "Supplierlist",
  SUPPLIER_DETAILS = "Supplierdetails",
  SUPPLIER_PRODUCTS = "Supplierproducts",
  SUPPLIER_IDENTITY_TYPES = "Supplieridentitytypes",
  SUPPLIER_BRANCH = "Supplierbranch",
  SUPPLIER_BANK = "Supplierbank",
  SUPPLIER_METADATA = "Suppliermetadata",
  SUPPLIER_DOCS = "Supplierdocs",
  SUPPLIER_CHARGES = "Suppliercharges",
  SUPPLIER_CHARGE_TYPE = "Supplierchargetype",
}

export enum SupplierProductApiEndpoints {
  SUPPLIER_PRODUCTS = "Supplierproducts",
  SUPPLIER_PRODUCT_DOC = "Supplierproductdoc",
  SUPPLIER_PRODUCT_DETAILS = "Supplierproductdetails",
}

export enum GrnApiEndpoints {
  GRN = "Grn",
  GRN_LIST = "Grnlist",
  GRN_STATUS = "Grnstatus",
  GRN_LIST_FILTER = "Grnlistfilter",
  UPDATE_GRN = "Updategrn",
  UPDATE_GRN_BASIC = "Updategrnbasic",
  UPDATE_GRN_DOCS = "Updategrndocs",
  UPDATE_GRN_PRODUCT = "Updategrnproduct",
  UPDATE_GRN_PRODUCT_RETURN = "Updategrnproductreturn",
  GRN_STATUS_TYPES = "Grnstatustypes",
  GRN_BULK_STATUS = "Grnbulkstatus",
  GRN_TRANSACTION_STATUS_TYPES = "Grntransactionstatustypes",
  GRN_DYNAMIC_LIST = "Grndynamiclist",
}

export enum ItemApiEndpoints {
  ITEM = "Item",
  IMPORT_ITEM_DATA = "Importitemdata",
  ITEM_META = "Itemmeta",
  CREATE_ITEMS = "Item/CreateItems",
  GET_VARIANT_TYPES = "Item/Getitemvarianttypes",
  CREATE_VARIANT_TYPE = "Item/Createitemvarianttype",
}

export enum UploadApiEndpoints {
  UPLOAD = "Upload/upload",
}

// Optional: Create a union type of all API endpoints if needed
export type ApiEndpoint = 
  | SettingApiEndpoints
  | LoginApiEndpoints
  | ReportApiEndpoints
  | SupplierApiEndpoints
  | SupplierProductApiEndpoints
  | GrnApiEndpoints
  | ItemApiEndpoints
  | UploadApiEndpoints;

// Optional: Create a grouped object for better organization
export const ApiEndpoints = {
  setting: SettingApiEndpoints,
  login: LoginApiEndpoints,
  report: ReportApiEndpoints,
  supplier: SupplierApiEndpoints,
  supplierProduct: SupplierProductApiEndpoints,
  grn: GrnApiEndpoints,
  item: ItemApiEndpoints,
  upload: UploadApiEndpoints,
} as const;